import React from "react";
import {
  table,
  subTitle,
  th,
  td,
  summary,
  hr
} from "../Shared/Styles";

export default function ApplicantDetails(props) {
  
  if (props.applicantDetails !== undefined) {
    return (
      <div>
        <h3 style={subTitle}>APPLICANT DETAILS</h3>
        <div>
        {props.applicantDetails.map((link) => (
          <>
              <div style={summary}>
                {link.lifeName}
                <hr style={hr} />
              </div>

              <div>
        <table style={table}>
        
          <>
          <tr>
            <th style={{border: '1px solid black', textAlign: 'center', fontSize: '15px', width: '6%', marginBottom: '20px'}}>Date of Birth</th>
            <td style={{border: '1px solid black', textAlign: 'left', fontSize: '15px', width: '6%', marginBottom: '13px', color: 'black', paddingLeft: '20px'}}>{link.dob}</td>
            <th style={th}>Sex</th>
            <td style={{border: '1px solid black', textAlign: 'left', fontSize: '15px', width: '6%', marginBottom: '13px', color: 'black', paddingLeft: '20px'}}>{link.gender}</td>
            <th style={{border: '1px solid black', textAlign: 'center', fontSize: '15px', width: '6%', marginBottom: '20px'}}>Smoker Status</th>
            <td style={{border: '1px solid black', textAlign: 'left', fontSize: '15px', width: '6%', marginBottom: '13px', color: 'black', paddingLeft: '20px'}}>{link.smokerStatus}</td>
          </tr>
          <tr>
            <th style={th}>Address</th>
            <td colSpan="5" style={td}>{link.address}</td>
          </tr>
          <tr>
            <th style={th}>Telephone</th>
            <td colSpan="5" style={td}>{link.telephone}</td>
          </tr>
          </>
         
        </table>
        </div>
        </>
        ))}
        </div>
      </div>
    );
  }
}
